import { fieldAgents, leadLadder } from '@constants/endpoints';
import { DefaultInterface, FetchLeadsData } from '@utils/types';
import { axiosInstance } from './index';

export const fetchLeadsData: FetchLeadsData = async (leadsParams) => {
  try {
    let response;
    if (leadsParams) {
      response = await axiosInstance.get(leadLadder, {
        params: {
          ...leadsParams,
        },
      });
    } else {
      response = await axiosInstance.get(leadLadder);
    }
    return response.data ?? false;
  } catch (error) {
    throw new Error();
  }
};
export const fetchFieldAgents: DefaultInterface = async () => {
  try {
    const response = await axiosInstance.get(fieldAgents);
    return response.data ?? false;
  } catch (error) {
    throw new Error();
  }
};
